/**
 * Payment Plans Response Types
 *
 */

import type { ResponseWithData } from '../utilities';

interface PaymentMethod<T = unknown> {
  name: string;
  paymentInfo: T;
  paymentPlanType: PAYMENT_PLAN_TYPE | string;
}

type CreditCard = PaymentMethod<CreditCardDetails[]>;

type Payments = PaymentMethod<PaymentPlan[]>;

interface CreditCardDetails {
  flag: string;
  info: CreditCardInfo[];
}

interface CreditCardInfo extends PaymentPlan {
  flagId: number;
  minimumInstallmentAmount: number;
}

interface PaymentPlansPayloadResponse {
  bankSlip: Payments;
  creditCard: CreditCard;
  linkPayment: Payments;
  centralPayment: Payments;
  pixPayment: Payments;
}

interface PaymentPlansNewPresenterPayloadResponse {
  payments: PaymentNewPresenter[];
}

export interface PaymentNewPresenter {
  paymentPlanType: string;
  name: string;
  description: string;
  textQuestion: string;
  information: string;
  hasInstallments: boolean;
  paymentInfo: PaymentInfoNewPresenter[];
}

export interface PaymentInfoNewPresenter {
  name: string;
  code: number;
  installments: number;
  paymentModeId: number;
  administrateTax: number;
  successMessage: string;
  description?: string;
}

export enum PAYMENT_PLAN_TYPE {
  BANK_ACCOUNT = 'bankAccount',
  BANK_BILLING = 'bankBilling',
  CASH = 'cash',
  CHECK = 'check',
  CREDIT_CARD = 'creditCard',
  DEPOSIT = 'deposit',
  MIXED = 'mixed',
  NONE = 'none',
  OTHER = 'other',
  UNIDENTIFIED_DEPOSIT = 'unidentifiedDeposit',
  PIX = 'pix',
}

export interface PaymentPlan {
  administrateTax: number;
  code: number;
  description: string;
  installments: number;
  isBlocked: boolean;
  name: string;
  paymentModeId: number;
}

export interface PaymentDetailRequestOptions {
  creditCardSchema?: number;
  installments: number;
  paymentCode: number;
  paymentMode: string;
}

export type PaymentPlansResponse = ResponseWithData<PaymentPlansPayloadResponse>;
export type PaymentPlansNewPresenterResponse =
  ResponseWithData<PaymentPlansNewPresenterPayloadResponse>;
